import {
  getKnowLedgeCenterMedia,
  removeMedia,
  uploadMedia,
} from '../../../features/knowledgeCenterSlice';
import { ThunkDispatch } from 'redux-thunk';
import { isAPIFailed, isAPISuccess } from '../../../utils/Util';
import { toast } from 'react-toastify';
import {
  CLICK_ACTIONS,
  maxFilesInAdminSettings,
  mediaForTypes,
} from '../../../utils/Constant';

export const defaultData = {
  title: '',
  order: '',
  thumbnail: undefined,
  media: undefined,
};

export const getKnowLedgeCenterFiles = (
  activeTab: number,
  dispatch: ThunkDispatch<any, any, any>
) => {
  dispatch(getKnowLedgeCenterMedia({ type: activeTab }));
};

export const onRemove = (
  id: number | string,
  setShowAlertPopUp: (param: boolean) => void,
  setRemoveMediaId: (param: any) => void
) => {
  setShowAlertPopUp(true);
  setRemoveMediaId(id);
};

export const handleRemove = (
  removeMediaId: number | string,
  activeTab: number,
  setLoader: (param: boolean) => void,
  dispatch: ThunkDispatch<any, any, any>
) => {
  if (removeMediaId) {
    setLoader(true);
    dispatch(removeMedia({ id: removeMediaId }))
      .then((fulfilled: any) => {
        setLoader(false);
        if (isAPISuccess(fulfilled.payload)) {
          toast.success(fulfilled.payload.responseInformation.responseMessage);
          getKnowLedgeCenterFiles(activeTab, dispatch);
        } else if (isAPIFailed(fulfilled.payload)) {
          toast.error(fulfilled.payload.responseInformation.responseMessage);
        }
      })
      .catch(() => {});
  }
};

export const alertPopupToggle = (
  action: string,
  removeMediaId: number | string,
  activeTab: number,
  setShowAlertPopUp: (param: boolean) => void,
  setRemoveMediaId: (param: any) => void,
  setLoader: (param: boolean) => void,
  dispatch: ThunkDispatch<any, any, any>
) => {
  if (action === CLICK_ACTIONS.APPROVE) {
    handleRemove(removeMediaId, activeTab, setLoader, dispatch);
  }
  setShowAlertPopUp(false);
  setRemoveMediaId(null);
};

export const handleUploadFile = (
  data: any,
  setData: (params: any) => void,
  activeTab: number,
  setLoader: (param: boolean) => void,
  dispatch: ThunkDispatch<any, any, any>
) => {
  const payload = new FormData();
  const { title, order, thumbnail = '', media = '' } = data;
  payload.append('knowledgeCenterTypeId', String(activeTab));
  payload.append('knowledgeCenterTitle', title);
  payload.append('knowledgeCenterOrder', order);
  payload.append('thumbnailFile', thumbnail);
  payload.append('mediaFile', media);
  setLoader(true);
  dispatch(uploadMedia(payload))
    .then((fulfilled: any) => {
      setLoader(false);
      if (isAPISuccess(fulfilled.payload)) {
        toast.success(fulfilled.payload.responseInformation.responseMessage);
        getKnowLedgeCenterFiles(activeTab, dispatch);
        setData(defaultData);
      } else if (isAPIFailed(fulfilled.payload)) {
        toast.error(fulfilled.payload.responseInformation.responseMessage);
      }
    })
    .catch(() => {
      setLoader(false);
      toast.error('Media Upload Failed');
    });
};

export const handleSubmit = (
  data: any,
  setData: (params: any) => void,
  activeTab: number,
  setLoader: (param: boolean) => void,
  dispatch: ThunkDispatch<any, any, any>
) => {
  let valid = true;
  if (!data.title) {
    toast.error('Title is required');
    valid = false;
  } else if (!data.order) {
    toast.error('Order is required');
    valid = false;
  } else if (
    Number(data.order) < 1 ||
    Number(data.order) > maxFilesInAdminSettings.knowledgeCenter
  ) {
    toast.error(
      `Order should be between 1 and ${maxFilesInAdminSettings.knowledgeCenter}`
    );
    valid = false;
  } else if (!data.thumbnail) {
    toast.error('Thumbnail is required');
    valid = false;
  } else if (!data.media) {
    toast.error('Media is required');
    valid = false;
  }
  if (valid) {
    handleUploadFile(data, setData, activeTab, setLoader, dispatch);
  }
};

export const handleCancel = (setData: (params: any) => void) => {
  setData(defaultData);
};
export const handleThumbnailUploadFiles = (
  fileArray: File[],
  mediaFor: string,
  thumbnailSupportedFiles: string[],
  mediaSupportedFiles: string[],
  thumbnailMaxSize: number,
  mediaMaxSize: number,
  data: any,
  setData: (value: any) => void
) => {
  if (fileArray.length) {
    const supportedFileArray = fileArray.filter((file) => {
      if (mediaFor === mediaForTypes.thumbnail)
        return thumbnailSupportedFiles.includes(
          `.${file.name.split('.').pop()?.toLowerCase()}`
        );
      return mediaSupportedFiles.includes(
        `.${file.name.split('.').pop()?.toLowerCase()}`
      );
    });
    const unsupportedFileArray = fileArray.filter((file) => {
      if (mediaFor === mediaForTypes.thumbnail)
        return !thumbnailSupportedFiles.includes(
          `.${file.name.split('.').pop()?.toLowerCase()}`
        );
      return !mediaSupportedFiles.includes(
        `.${file.name.split('.').pop()?.toLowerCase()}`
      );
    });

    if (unsupportedFileArray.length > 0) {
      if (mediaFor === mediaForTypes.thumbnail)
        toast.error(
          `Please upload only ${thumbnailSupportedFiles.join(', ')} files.`
        );
      else {
        toast.error(
          `Please upload only ${mediaSupportedFiles.join(', ')} files.`
        );
      }
      return;
    }

    if (supportedFileArray.length > 1) {
      toast.error(`Please choose only 1 file`);
      return;
    }
    const fileSize = supportedFileArray[0].size;
    if (mediaFor === mediaForTypes.thumbnail && fileSize > thumbnailMaxSize) {
      toast.error(`File size should be less than ${thumbnailMaxSize / 1024}kb`);
      return;
    } else if (mediaFor === 'media' && fileSize > mediaMaxSize) {
      toast.error(
        `File size should be less than ${mediaMaxSize / (1024 * 1024)}mb`
      );
      return;
    }
    setData({
      ...data,
      [mediaFor === mediaForTypes.thumbnail ? 'thumbnail' : 'media']:
        supportedFileArray[0],
    });
  }
};
